/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalProcessNamesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IInternalProcessNamesQuery = { __typename?: 'Query'; internalProcessNames: Array<string> };

export const InternalProcessNamesDocument = gql`
  query InternalProcessNames {
    internalProcessNames
  }
`;

/**
 * __useInternalProcessNamesQuery__
 *
 * To run a query within a React component, call `useInternalProcessNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalProcessNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalProcessNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalProcessNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>(
    InternalProcessNamesDocument,
    options,
  );
}
export function useInternalProcessNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>(
    InternalProcessNamesDocument,
    options,
  );
}
// @ts-ignore
export function useInternalProcessNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>;
export function useInternalProcessNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalProcessNamesQuery | undefined, IInternalProcessNamesQueryVariables>;
export function useInternalProcessNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalProcessNamesQuery, IInternalProcessNamesQueryVariables>(
    InternalProcessNamesDocument,
    options,
  );
}
export type InternalProcessNamesQueryHookResult = ReturnType<typeof useInternalProcessNamesQuery>;
export type InternalProcessNamesLazyQueryHookResult = ReturnType<typeof useInternalProcessNamesLazyQuery>;
export type InternalProcessNamesSuspenseQueryHookResult = ReturnType<typeof useInternalProcessNamesSuspenseQuery>;
export type InternalProcessNamesQueryResult = Apollo.QueryResult<
  IInternalProcessNamesQuery,
  IInternalProcessNamesQueryVariables
>;
